import { shouldShowTranslationFailed } from './shouldShowTranslationFailed';

/** The language the entity's transcript and titles are actually in: its
 *  subtitle `language`, except after a failed translation, when the original
 *  transcript (in `audio_language`) was kept. Readers of the content's language
 *  (e.g. filler-word detection) use this instead of `language`. */
export function effectiveContentLanguage(
  entity:
    | { language?: string | null; audio_language?: string | null; translation_status?: string | null }
    | null
    | undefined,
): string | null | undefined {
  if (shouldShowTranslationFailed(entity)) return entity?.audio_language ?? entity?.language;
  return entity?.language;
}
